// Gating for the Billingo invoicing flow. The ENTIRE flow (all three document
// types) is available only for partners with per-trip invoicing turned on;
// monthly-billed partners never see it.
//
// `invoicing_enabled` is a numeric flag on the Partner (1 = on, 0/undefined =
// off). It's opt-in: a partner sees the flow only when explicitly switched on
// in the Partner modal.
export default function isInvoicingEnabled(partner) {
  if (!partner) return false;
  return Number(partner.invoicing_enabled) === 1;
}
